import React from 'react';
import styled from 'styled-components';
import AddButton from './AddButton';

const SectionWrapper = styled.div`
  width: 70%;
  height: 100%;
`;

const Content= styled.div`
  padding: 1.6rem 0;
`;

const Title = styled.h1`
  /* font-family: 'Pacifico', cursive; */
  font-size: 3rem;
  color: #eee;
  margin: 1rem 0;
`;

const BlogsSection = () => {
  return (
    <SectionWrapper>
      <Title>Featured Blogs</Title>
      <AddButton onClick={'toggleModal'} />
    </SectionWrapper>
  );
};

export default BlogsSection;
